import { getKeys } from './getKeys'

export const transferRecordTranslations = {
  // Modal titles
  WAS_HOSPITALISED: '{{name}} was hospitalised',
  WAS_TRANSFERRED: '{{name}} was transferred to another care setting',
  HAS_RETURNED: '{{name}} has returned',
  WAS_DISCHARGED: '{{name}} was discharged',

  // Form labels
  DATE_OF_HOSPITALISATION: 'Date of hospitalisation',
  DATE_OF_TRANSFER: 'Date of transfer',
  DATE_OF_RETURN: 'Date of return',
  DATE_OF_DISCHARGE: 'Date and time of discharge',
  DISCHARGED_FROM: 'Discharged from',
  CARE_SETTING_TYPE: 'Care setting type',
  CARE_SETTING_DOMICILIARY: 'Domiciliary',
  CARE_SETTING_MENTAL_HEALTH: 'Mental Health',
  CARE_SETTING_LEARNING_DISABILITIES: 'Learning Disabilities',
  REASON_FOR_HOSPITALISATION: 'Reason for hospitalisation',
  REASON_FOR_TRANSFER: 'Reason for transfer',
  TRANSFERRED_FROM: 'Transferred from',
  TRANSFERRED_TO: 'Transferred to',
  LOCATION_NAME: 'Location name',
  ADDRESS: 'Address',
  HOSPITAL_NAME: 'Hospital name',
  HOSPITAL_ADDRESS: 'Hospital address',
  ORIGINAL_TRANSFER_REASON: 'Original transfer reason: {{reason}}',

  // Status option
  TRANSFERRED_TO_ANOTHER_CARE_SETTING: 'Transferred to another care setting',

  // Validation
  DATE_REQUIRED: 'Date is required',
  REASON_REQUIRED: 'Reason is required',
  LOCATION_NAME_REQUIRED: 'Location name is required',
  DISCHARGED_FROM_REQUIRED: 'Discharged from is required',

  // Page Header
  TRANSFER_AND_HOSPITALISATION_RECORDS: "{{name}}'s Transfer records",
  TRANSFER_RECORDS_TOOLTIP:
    'Records are created automatically when changing status to or from Hospitalised, Transferred, or Discharged.',

  // List
  NO_TRANSFER_RECORDS:
    'No transfer, hospitalisation or discharge records found',
  NO_TRANSFER_RECORDS_DESCRIPTION:
    'There are no transfer, hospitalisation or discharge records for this resident yet.',
  RECORD_TYPE: 'Record type',
  HOSPITALISATION: 'Hospitalisation',
  TRANSFER: 'Transfer',
  RETURN: 'Return',
  DISCHARGE: 'Discharge',
  ADDED_BY: 'Added by {{name}}',
  CREATED_BY: 'Created by',
  CREATED_BY_ON_DATE: '{{name}} on {{date}}',
  CARE_SETTING_TYPE_LABEL: 'Care setting type',
  TRANSFERRED_FROM_LABEL: 'Transferred from',
  TRANSFERRED_TO_LABEL: 'Transferred to',
  DISCHARGE_LOCATION_LABEL: 'Location of discharge',

  // Error
  TRANSFER_RECORD_FAILED:
    'Failed to save transfer record. The status change was saved successfully.',

  // Common
  SAVE: 'Save',
  CANCEL: 'Cancel',
  BACK: 'Back',
  NEXT: 'Next'
}

export const transferRecordConstants = getKeys(transferRecordTranslations)
